import React from "react";
import { ContributionFlagsContainer } from "../../../containers";

const ContributionFlagsReport = (props) => {
  return <ContributionFlagsContainer {...props} />;
};

export default ContributionFlagsReport;
